import type React from 'react';

import type * as api from '@gitbook/api-client';

import { apiClient } from '../../state';
import { ContentEditableIcon } from '../Content';

/**
 * Displays an editable emoji or icon for a space.
 */
export function SpaceEditableIcon(props: {
    className?: string;
    size?: number;
    space: api.Space;
    withBackground?: boolean;
}): React.ReactElement {
    const { space, size = 18, className, withBackground } = props;

    const onClear = async () => {
        await apiClient.spaces.updateSpaceById(space.id, {
            emoji: null,
            icon: null,
        });
    };

    const onEmojiChange = async (emoji: string) => {
        await apiClient.spaces.updateSpaceById(space.id, {
            emoji,
        });
    };

    const onIconURLChange = async (icon: string) => {
        await apiClient.spaces.updateSpaceById(space.id, {
            icon,
        });
    };

    return (
        <ContentEditableIcon
            size={size}
            className={className}
            uploadTo={{
                kind: 'space_icon',
                space: space.id,
            }}
            emoji={space.emoji}
            iconURL={space.urls.icon}
            fallbackText={space.title}
            onClear={onClear}
            onEmojiChange={onEmojiChange}
            onIconURLChange={onIconURLChange}
            withBackground={withBackground}
        />
    );
}
